// extracted by mini-css-extract-plugin
export default {"comment":"comment_comment__V9puU","containerInput":"comment_containerInput__UZisj","bottom":"comment_bottom__P1YbO"};